import { render, staticRenderFns } from "./hotNewsList.vue?vue&type=template&id=5bd69a14"
import script from "./hotNewsList.vue?vue&type=script&lang=js"
export * from "./hotNewsList.vue?vue&type=script&lang=js"
import style0 from "./hotNewsList.vue?vue&type=style&index=0&id=5bd69a14&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports